<template>
  <v-layout fill-height justify-space-between>
    <v-layout column  pa-0>
      <v-layout>
        <scroll-area>
          <template slot="body">
            <v-layout v-if="showFields" column fill-height>
              <v-expansion-panel
                light               
                v-for="(bridge, i) in getBridges" :key="'bridge_' + i"
              >
                <v-expansion-panel-content expand-icon="" style="background-color: white; border: solid 1px #EBEBEB">
                  <template v-slot:header>
                    <v-layout justify-start align-center @click="() => exPanelClick(bridge)">
                      <v-icon :style="exPanel == bridge ? 'transform: rotate(-180deg);' : ''">expand_more</v-icon>
                      <v-flex shrink px-3>
                        <span class="body-2 text-uppercase">{{$t(bridge)}}</span>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-card style="max-height: 100%; padding-top: 8px;">
                    <v-flex v-for="(field, name) in getFields" :key="bridge + '_' + name">
                      <v-flex shrink v-if="!field.fields && field.show == 'true' && field.group == bridge && field.place == 'config' && field.type != 'boolean'" px-0 >
                        <v-layout shrink px-2>
                          <v-flex xs4 shrink px-0 pb-2>
                            <v-text-field
                              :value="$t(field.name)"
                              light
                              outline
                              flat
                              readonly
                              disabled
                              class="backgrey"
                              hide-details
                              :rows="1"
                              color="white"
                            >
                            </v-text-field>
                          </v-flex>
      
                          <v-flex xs8 shrink px-0 pb-2>
                            <v-text-field
                              :value="field.type == 'text' ? field.value : $t(field.value)"
                              :type="field.hide_pass ? 'password' : 'text'"
                              light
                              auto-grow
                              outline
                              readonly
                              class="white"
                              persistent-hint
                              hide-details
                              :rows="1"
                              color="accent"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex shrink v-if="field.fields" px-0 >
                        <v-flex v-for="(sfield, name) in field.fields" :key="'s' + name" v-show="sfield.show == 'true' && sfield.place == 'config' && sfield.name != 'name'">
                          <v-layout shrink v-if="sfield.group == bridge && sfield.type != 'boolean'" px-2 pb-2>
                            <v-flex xs4 shrink px-0 pb-0>
                              <v-text-field
                                :value="$t(sfield.name)"
                                light
                                outline
                                flat
                                readonly
                                disabled
                                class="backgrey"
                                hide-details
                                :rows="1"
                                color="white"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex xs8 shrink px-0 pb-0>         
                              <v-text-field
                                :value="sfield.type == 'text' ? sfield.value : $t(sfield.value)"
                                :type="sfield.hide_pass ? 'password' : 'text'"
                                light
                                auto-grow
                                outline
                                readonly
                                class="white"
                                persistent-hint
                                hide-details
                                :rows="1"
                                color="accent"
                              >
                              </v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-flex shrink v-if="sfield.group == bridge && sfield.type == 'boolean'"  pl-2 >
                            <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'sfield.value'" small disabled light color="secondary" v-model="sfield.value">
                              <template v-slot:label>
                                <span class="blacktext--text">{{$t(sfield.name)}}</span>
                              </template>
                            </v-checkbox>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                    </v-flex>

                    <v-flex xs12 v-if="!field.fields && field.place == 'config' && field.type == 'boolean'" v-for="(field, name) in getFields" :key="bridge + '_boolean_' + name" pl-2>
                      <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'field.value'"
                        small
                        light
                        color="secondary"
                        disabled
                        v-if="field.show == 'true' && field.group == bridge"
                        v-model="field.value"
                      >
                        <template v-slot:label>
                          <span class="blacktext--text">{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-flex v-for="(field, name) in getFields" :key="'nobridge_' + name">
                <v-flex shrink v-if="!field.fields && field.show == 'true' && !field.group && field.place == 'config' && field.type != 'boolean'" px-0 >
                  <v-layout shrink px-2  pt-2>
                    <v-flex xs4 shrink px-0 pb-2>
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs8 shrink px-0 pb-2>      
                      <v-text-field
                        :value="field.type == 'text' ? field.value : $t(field.value)"
                        :type="field.hide_pass ? 'password' : 'text'"
                        light
                        auto-grow
                        outline
                        readonly
                        class="white"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex shrink v-if="field.fields" px-0 >
                  <v-flex v-for="(sfield, name) in field.fields" :key="'s' + name" v-show="sfield.show == 'true' && sfield.place == 'config' && sfield.name != 'name'">
                    <v-layout shrink v-if="!sfield.group && sfield.type != 'boolean'" px-2>
                      <v-flex xs4 shrink px-0 pb-2>
                        <v-text-field
                          :value="$t(sfield.name)"
                          light
                          outline
                          flat
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs8 shrink px-0 pb-2>     
                        <v-text-field
                          :value="sfield.type == 'text' ? sfield.value : $t(sfield.value)"
                          :type="sfield.hide_pass ? 'password' : 'text'"
                          light
                          auto-grow
                          outline
                          readonly
                          disabled
                          class="white"
                          persistent-hint
                          hide-details
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-flex shrink v-if="!sfield.group&& sfield.type == 'boolean'"  pl-2 >
                      <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'sfield.value'" small disabled light color="secondary" v-model="sfield.value">
                        <template v-slot:label>
                          <span class="blacktext--text">{{$t(sfield.name)}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-flex>

              <v-flex xs12 v-if="!field.fields && field.place == 'config' && field.type == 'boolean'" v-for="(field, name) in getFields" :key="'nobridge_boolean_' + name" pl-2>
                <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'field.value'"
                  small
                  light
                  color="secondary"
                  disabled
                  v-if="field.show == 'true' && !field.group"
                  v-model="field.value"
                >
                  <template v-slot:label>
                    <span class="blacktext--text">{{$t(field.name)}}</span>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </template>
        </scroll-area>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface RuleItem {
  community: string
  user: string
  level: string
  authprotocol: string
  authkey: string
  privprotocol: string
  privkey: string
}

interface RulesVer3 {
  [key: string]: RuleItem
}

interface RulesSnmp {
  noVer: RuleItem
  ver1: RuleItem
  ver3: RulesVer3
}

interface RulesData {
  snmp: RulesSnmp
}

interface ModelFields {
  [key: string]: any
}

interface ModelObj {
  snmp?: {
    version?: number
    level?: string
    [key: string]: any
  }
  [key: string]: any
}

interface ModelData {
  fields: ModelFields
  obj: ModelObj
  items: Record<string, any>
  bridges: Record<string, any>
  manage: Record<string, any>
  links: any[]
  template: Record<string, any>
}

interface MetaData {
  [key: string]: any
}

interface DeviceConfigurationData {
  $id?: string
  cls?: string
  template?: string
  snmp?: {
    version?: number
    level?: string
    [key: string]: any
  }
  [key: string]: any
}

export default Vue.extend({
  name: 'DEVICE_CONFIGURATION',

  components: {
    scrollArea,
  },

  props: {
    data: {
      type: Object as () => DeviceConfigurationData,
      default: () => ({})
    },
  },

  data(): {
    data$id: string | null
    exPanel: any | null
    showFields: boolean
    meta: MetaData
    model: ModelData
    rules: RulesData
  } {
    return {
      data$id: null,
      exPanel: null,
      showFields: true,
      meta: {},
      model: {
        fields: {},
        obj: {},
        items: {},
        bridges: {},
        manage: {},
        links: [],
        template: {},
      },
    }
  },

  computed: {
    getData(): DeviceConfigurationData {
      return this.data
    },

    getFields(): ModelFields {
      return this.model.fields
    },

    getBridges(): string[] {
      return this.model.bridges ? Object.keys(this.model.bridges) : []
    },
  },

  watch: {
    data: {
      handler(newVal: DeviceConfigurationData): void {
        console.log('WATCH', this.$options.name, 'DATA###', JSON.parse(JSON.stringify(newVal)))
        if (!newVal?.$id) return
        this.setup('watch')
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  methods: {
    setup(caller: string): void {
      console.log(this.$options.name, 'setup', caller)
      this.data$id = this.getData.$id || null
      this.reset()
      this.loadMeta()
    },

    async loadMeta(caller?: string): Promise<void> {
      this.meta = await this.$loadMeta(this.getData, this.$options.name)
      this.model = await this.$prepareMeta(this.meta, this.$options.name)
      
      const template$ = await this.$bridge.getTemplates(this.getData.cls, { id: this.getData.template })
      this.$set(this.model, 'template', template$[0])
      this.showFields = true
      this.prepareData()
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta)
        console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model
        this.checkSnmpVersion()
      } catch (error) {
        this.setLoader('prepareData', false)
        console.error('CATCH', this.$options.name, 'prepareData', 'SMTH WRONG', error)
      }
    },

    checkSnmpVersion(): void {
      const version = this.model?.obj?.snmp?.version || this.getData.snmp?.version
      
      if (version) {
        this.setLoader('checkSnmpVersion', true)
        
        if (version == 1 || version == 2) {
          for (const name of Object.keys(this.$store.getters.getDeviceNails.update.rules.snmp.ver1)) {
            if (this.model.fields?.snmp?.fields[name]) {
              this.$set(this.model.fields.snmp.fields[name], 'show', this.$store.getters.getDeviceNails.update.rules.snmp.ver1[name as keyof RuleItem])
            }
          }
        }
        
        if (version == 3) {
          const level = this.model.obj?.snmp?.level || this.getData.snmp?.level
          
          if (!level) {
            for (const name of Object.keys(this.$store.getters.getDeviceNails.update.rules.snmp.ver3['no auth, no privacy'])) {
              if (this.model.fields?.snmp?.fields[name]) {
                this.$set(this.model.fields.snmp.fields[name], 'show', this.$store.getters.getDeviceNails.update.rules.snmp.ver3['no auth, no privacy'][name as keyof RuleItem])
              }
            }
          } else {
            for (const name of Object.keys(this.$store.getters.getDeviceNails.update.rules.snmp.ver3[level])) {
              if (this.model.fields?.snmp?.fields[name]) {
                this.$set(this.model.fields.snmp.fields[name], 'show', this.$store.getters.getDeviceNails.update.rules.snmp.ver3[level][name as keyof RuleItem])
              }
            }
          }
        }
        this.setLoader('checkSnmpVersion', false)
      } else {
        this.setLoader('checkSnmpVersion', true)
        
        for (const name of Object.keys(this.$store.getters.getDeviceNails.update.rules.snmp.noVer)) {
          if (this.model.fields?.snmp?.fields[name]) {
            this.$set(this.model.fields.snmp.fields[name], 'show', this.$store.getters.getDeviceNails.update.rules.snmp.noVer[name as keyof RuleItem])
          }
        }
        this.setLoader('checkSnmpVersion', false)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.model = {
        fields: {},
        obj: {},
        items: {},
        bridges: {},
        manage: {},
        links: [],
        template: {},
      }
    },

    exPanelClick(e: any): void {
      console.log(this.$options.name, 'exPanelClick', e)
      this.exPanel = this.exPanel === e ? null : e
    },
  },
})
</script>

<style lang="css" scoped>
.customToolbar {
  background-color: #58595B;
  height: 48px;
  font-size: 20px;
  font-weight: 500;
}

.terminal {
    background-color: #000000;
    color: #fafafa;
    padding: 2px;
    /* height: calc(100% - 19px); */
  }
</style>
